module.exports = __webpack_public_path__ + "static/media/Photo_symbol_selected.a58591f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/Photo_symbol_selected.svg
// module id = 1333
// module chunks = 0